<template>
  <div>
    <b-card
      no-body
      class="mb-1"
    >
      <div class="d-flex flex-wrap align-items-center cabecalho">
        <b-nav
          tabs
          class="abas"
        >
          <b-nav-item
            v-for="opcao in situacoes"
            :key="opcao.valor"
            :active="situacao === opcao.valor"
            @click="mudarSituacao(opcao.valor)"
          >
            {{ opcao.rotulo }}
          </b-nav-item>
        </b-nav>

        <div class="p-1 ml-auto d-flex flex-wrap align-items-center filtros">
          <button
            class="btn btn-sm btn-outline-secondary"
            :disabled="carregando"
            @click="carregar"
          >
            {{ carregando ? $t('retention.index.refreshing') : $t('retention.index.refresh') }}
          </button>

          <router-link
            class="btn btn-sm btn-primary"
            :to="{ name: 'retention-occurrences' }"
          >
            <feather-icon
              icon="PlusIcon"
              size="14"
              class="mr-25"
            />
            {{ $t('retention.index.newRetention') }}
          </router-link>

          <span class="resumo">
            <strong>{{ paginacao.total }}</strong> {{ $t('retention.index.records') }}
          </span>
        </div>
      </div>
    </b-card>

    <div
      v-if="situacao !== 'returned'"
      class="row mb-1"
    >
      <div
        v-for="t in totais"
        :key="t.rotulo"
        class="col-4"
      >
        <b-card
          no-body
          class="tot"
        >
          <div
            class="tot__valor"
            :class="t.classe"
          >
            {{ t.valor }}
          </div>
          <div class="tot__rotulo">
            {{ t.rotulo }}
          </div>
        </b-card>
      </div>
    </div>

    <b-card no-body>
      <div
        v-if="carregando"
        class="text-center py-4"
      >
        <b-spinner
          small
          variant="primary"
        />
      </div>

      <div
        v-else-if="retencoes.length === 0"
        class="text-center text-muted py-4"
      >
        {{ textoVazio }}
      </div>

      <table
        v-else
        class="table table-sm mb-0 lista"
      >
        <thead>
          <tr>
            <th class="col-per">
              {{ $t('retention.index.table.when') }}
            </th>
            <th>{{ $t('retention.index.table.equipment') }}</th>
            <th class="text-right col-qtd">
              {{ $t('retention.index.table.qty') }}
            </th>
            <th>{{ $t('retention.fields.whereKept') }}</th>
            <th>{{ $t('retention.fields.receivedBy') }}</th>
            <th>{{ $t('retention.fields.team') }}</th>
            <th class="col-proto">
              {{ $t('retention.fields.occurrence') }}
            </th>
            <th class="col-sit">
              {{ $t('retention.index.table.status') }}
            </th>
            <th class="text-right col-acoes" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="r in retencoes"
            :key="r.id"
            class="linha"
            :class="{ recuperada: r.returned_at }"
            @click="abrir(r)"
          >
            <td :title="detalhe(r)">
              {{ periodo(r) }}
            </td>
            <td>
              <div class="item__nome">
                {{ r.equipment ? r.equipment.name : '—' }}
              </div>
              <small
                v-if="detalheEquipamento(r)"
                class="text-muted"
              >{{ detalheEquipamento(r) }}</small>
            </td>
            <td class="text-right num">
              {{ r.quantity }}
              <small
                v-if="r.returned_quantity && !r.returned_at"
                class="text-muted d-block"
              >{{ r.returned_quantity }} {{ $t('retention.index.returnedSuffix') }}</small>
            </td>
            <td>
              <span
                v-if="destino(r)"
                class="local"
              >{{ destino(r) }}</span>
              <span
                v-else
                class="text-muted"
              >{{ $t('retention.common.notInformed') }}</span>
            </td>
            <td>
              <div v-if="r.responsible_name">
                {{ r.responsible_name }}
              </div>
              <span
                v-else
                class="text-muted"
              >&mdash;</span>
              <SignatureViewer
                v-if="r.has_signature"
                :url="urlAssinatura(r, 'signature')"
                :rotulo="$t('retention.index.viewSignature')"
                :titulo="$t('retention.index.signatureTitle', { name: r.equipment ? r.equipment.name : '' })"
              />
            </td>
            <td>{{ r.team ? r.team.name : '—' }}</td>
            <td>
              <span
                v-if="r.occurrence"
                class="badge badge-secondary text-monospace"
              >{{ r.occurrence.protocol }}</span>
              <span
                v-else
                class="text-muted"
              >—</span>
            </td>
            <td>
              <span :class="r.returned_at ? 'selo selo--recuperado' : 'selo selo--retido'">
                {{ r.returned_at ? $t('retention.common.recovered') : $t('retention.common.pending') }}
              </span>
            </td>
            <td class="text-right">
              <button
                v-if="!r.returned_at"
                class="btn btn-sm btn-outline-success"
                :disabled="recuperando === r.id"
                :title="$t('retention.index.recoverButton')"
                @click="abrirRecuperacao(r)"
              >
                <feather-icon
                  icon="SettingsIcon"
                  size="15"
                />
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="paginacao.last_page > 1"
        class="d-flex justify-content-end p-1"
      >
        <pagination
          v-model="paginacao.current_page"
          :options="opcoesPaginacao"
          :records="paginacao.total"
          :per-page="paginacao.per_page"
          @paginate="carregar"
        />
      </div>
    </b-card>

    <b-modal
      v-model="modalAberto"
      :title="$t('retention.index.recoverModalTitle')"
      size="md"
      centered
      lazy
      hide-footer
    >
      <template v-if="alvo">
        <p class="mb-1">
          <strong>{{ alvo.equipment ? alvo.equipment.name : '—' }}</strong>
          &mdash; {{ alvo.pending_quantity }} {{ $t('retention.common.pendingOf', { total: alvo.quantity }) }}
          <span
            v-if="destino(alvo)"
            class="text-muted"
          >{{ $t('retention.index.inDestination', { where: destino(alvo) }) }}</span>
        </p>

        <div class="form-row">
          <div class="form-group col-4">
            <label>{{ $t('retention.common.quantityReturned') }}</label>
            <input
              v-model.number="formRec.quantity"
              type="number"
              class="form-control"
              min="1"
              :max="alvo.pending_quantity"
            >
          </div>
          <div class="form-group col-8">
            <label>{{ $t('retention.common.returnedBy') }}</label>
            <input
              v-model="formRec.responsible_name"
              type="text"
              class="form-control"
              maxlength="180"
              :placeholder="$t('retention.common.optional')"
            >
          </div>
        </div>

        <div class="form-group">
          <label>{{ $t('retention.common.notes') }}</label>
          <textarea
            v-model="formRec.notes"
            class="form-control"
            rows="2"
            maxlength="255"
            :placeholder="$t('retention.common.optional')"
          />
        </div>

        <div
          v-if="parcial"
          class="aviso-parcial"
        >
          {{ $t('retention.common.partialWarning', { count: alvo.pending_quantity - formRec.quantity }) }}
        </div>

        <div
          v-if="alvo.holds_team"
          class="liberar-equipe"
        >
          <div class="liberar-equipe__texto">
            <strong>{{ $t('retention.releaseTeam.button') }}</strong>
            <small class="text-muted d-block">
              {{ alvo.team_locked ? $t('retention.releaseTeam.hint') : $t('retention.releaseTeam.notLocked') }}
            </small>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-outline-warning"
            :disabled="!alvo.team_locked || salvando"
            @click="liberarDoModal"
          >
            <feather-icon
              icon="UnlockIcon"
              size="14"
              class="mr-25"
            />
            {{ $t('retention.releaseTeam.button') }}
          </button>
        </div>

        <div
          class="d-flex justify-content-end mt-1"
          style="gap: 8px"
        >
          <button
            type="button"
            class="btn btn-outline-secondary"
            :disabled="salvando"
            @click="modalAberto = false"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-success"
            :disabled="salvando || !quantidadeValida"
            @click="confirmarRecuperacao"
          >
            {{ salvando ? $t('retention.common.saving') : $t('retention.common.confirm') }}
          </button>
        </div>
      </template>
    </b-modal>

    <retention-release-team-modal
      ref="releaseModal"
      @released="aoLiberarEquipe"
    />
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import opcoesPaginacao from '@/libs/paginationOptions'
import ApiErrorMixin from '@/mixins/ApiErrorMixin'
import EquipmentRetentionEventsMixin from '@/mixins/EquipmentRetentionEventsMixin'
import RetentionReleaseTeamModal from '@/components/RetentionReleaseTeamModal.vue'
import SignatureViewer from '@/components/SignatureViewer.vue'

export default {
  name: 'RetentionIndex',
  components: { SignatureViewer, Pagination, RetentionReleaseTeamModal },
  mixins: [ApiErrorMixin, EquipmentRetentionEventsMixin],

  data() {
    return {
      retencoes: [],
      resumo: { itens_retidos: 0, ocorrencias: 0, equipamentos: 0 },
      paginacao: {
        current_page: 1, per_page: 20, last_page: 1, total: 0,
      },
      carregando: false,
      recuperando: null,
      modalAberto: false,
      salvando: false,
      alvo: null,
      formRec: { quantity: 1, responsible_name: '', notes: '' },
      situacao: 'open',
      situacoes: [
        { valor: 'open', rotulo: this.$t('retention.index.tabOpen') },
        { valor: 'returned', rotulo: this.$t('retention.index.tabReturned') },
        { valor: 'all', rotulo: this.$t('retention.index.tabAll') },
      ],
    }
  },

  computed: {
    opcoesPaginacao() {
      return opcoesPaginacao
    },

    textoVazio() {
      if (this.situacao === 'returned') return this.$t('retention.index.emptyReturned')
      if (this.situacao === 'all') return this.$t('retention.index.emptyAll')

      return this.$t('retention.index.emptyOpen')
    },

    parcial() {
      return this.alvo !== null
        && this.quantidadeValida
        && this.formRec.quantity < this.alvo.pending_quantity
    },

    quantidadeValida() {
      if (!this.alvo) return false
      const q = Number(this.formRec.quantity)

      return q >= 1 && q <= this.alvo.pending_quantity
    },

    totais() {
      return [
        {
          rotulo: this.$t('retention.index.totalRetainedItems'),
          valor: this.resumo.itens_retidos,
          classe: 'tot__valor--alerta',
        },
        { rotulo: this.$t('retention.index.totalOccurrences'), valor: this.resumo.ocorrencias, classe: '' },
        {
          rotulo: this.$t('retention.index.totalDistinctEquipment'),
          valor: this.resumo.equipamentos,
          classe: '',
        },
      ]
    },
  },

  mounted() {
    this.carregar()
    this.watchRetentionEvents()
  },

  methods: {
    onRetentionEvent() {
      this.carregar()
    },

    abrir(r) {
      this.$router.push({ name: 'retention-detail', params: { id: r.id } })
    },

    destino(r) {
      if (r.establishment && r.establishment.establishment_name) return r.establishment.establishment_name

      return r.location || ''
    },

    urlAssinatura(r, tipo) {
      return `${this.$store.state.api}equipment/retentions/${r.id}/${tipo}`
    },

    mudarSituacao(valor) {
      if (this.situacao === valor) return

      this.situacao = valor
      this.paginacao.current_page = 1
      this.carregar()
    },

    async carregar() {
      this.carregando = true
      try {
        const res = await this.$http.get(`${this.$store.state.api}equipment/retentions`, {
          params: {
            situacao: this.situacao,
            page: this.paginacao.current_page,
            per_page: this.paginacao.per_page,
          },
        })
        const pg = res.data.data || {}
        this.retencoes = pg.data || []
        this.paginacao.total = pg.total || 0
        this.paginacao.last_page = pg.last_page || 1
        this.paginacao.current_page = pg.current_page || 1
        this.resumo = res.data.summary || this.resumo
      } catch (e) {
        this.retencoes = []
        this.$message(this.$t('retention.common.errorTitle'), this.apiErrorText(e, this.$t('retention.index.loadError')), 'error')
      } finally {
        this.carregando = false
      }
    },

    abrirRecuperacao(r) {
      this.alvo = r
      this.formRec = { quantity: r.pending_quantity, responsible_name: '', notes: '' }
      this.modalAberto = true
    },

    async confirmarRecuperacao() {
      if (!this.quantidadeValida) return

      this.salvando = true
      try {
        await this.$http.post(`${this.$store.state.api}equipment/retentions/${this.alvo.id}/return`, {
          quantity: Number(this.formRec.quantity),
          responsible_name: this.formRec.responsible_name || null,
          notes: this.formRec.notes || null,
        })
        this.$message(this.$t('retention.common.successTitle'), this.$t('retention.common.recoverySuccess'), 'success')
        this.modalAberto = false
        this.carregar()
      } catch (e) {
        this.$message(this.$t('retention.common.errorTitle'), this.apiErrorText(e, this.$t('retention.index.recoverError')), 'error')
      } finally {
        this.salvando = false
      }
    },

    // Abre a escolha da posição para liberar a equipe sem dar baixa; a janela de recuperar fecha ao concluir.
    liberarDoModal() {
      this.$refs.releaseModal.open(this.alvo)
    },

    aoLiberarEquipe() {
      this.modalAberto = false
      this.carregar()
    },

    detalheEquipamento(r) {
      if (!r.equipment) return ''

      const unidade = (r.equipment.unit && r.equipment.unit.abbreviation)
        || (r.equipment.type && r.equipment.type.unit && r.equipment.type.unit.abbreviation)
        || ''
      const partes = []

      if (r.equipment.measure_value) partes.push(`${r.equipment.measure_value} ${unidade}`.trim())
      if (r.equipment.serial) partes.push(r.equipment.serial)

      return partes.join(' · ')
    },

    periodo(r) {
      const inicio = this.curto(r.retained_at)
      if (!r.returned_at) return this.$t('retention.index.since', { date: inicio })

      const mesmoDia = (r.retained_at || '').slice(0, 10) === (r.returned_at || '').slice(0, 10)
      const fim = mesmoDia ? this.hora(r.returned_at) : this.curto(r.returned_at)

      return `${inicio} → ${fim}`
    },

    detalhe(r) {
      const inicio = r.retained_by
        ? this.$t('retention.index.retainedOnBy', { date: this.dataHora(r.retained_at), name: r.retained_by.name })
        : this.$t('retention.index.retainedOnNoBy', { date: this.dataHora(r.retained_at) })

      if (!r.returned_at) return inicio

      const fim = r.returned_by
        ? this.$t('retention.index.recoveredOnBy', { date: this.dataHora(r.returned_at), name: r.returned_by.name })
        : this.$t('retention.index.recoveredOnNoBy', { date: this.dataHora(r.returned_at) })

      return `${inicio}\n${fim}`
    },

    curto(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
      })
    },

    hora(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },

    dataHora(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('pt-BR')
    },
  },
}
</script>

<style scoped>
.cabecalho {
  padding-left: 0.5rem;
}

.abas {
  margin-bottom: 0;
}

.filtros {
  gap: 10px;
}

.resumo {
  font-size: 12px;
  color: #8592a3;
}

.num {
  font-variant-numeric: tabular-nums;
}

.linha {
  cursor: pointer;
}

.linha:hover {
  background: #f8f8fb;
}

.dark-layout .linha:hover {
  background: #232a3d;
}

.tot {
  padding: 10px 14px;
  margin-bottom: 0;
}

.tot__valor {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  color: #5e5873;
}

.tot__valor--alerta {
  color: #ff9f43;
}

.tot__rotulo {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #b9b9c3;
  margin-top: 2px;
}

.aviso-parcial {
  padding: 8px 12px;
  border-radius: 6px;
  background: #fdf3e4;
  color: #b45309;
  font-size: 12.5px;
}

.dark-layout .aviso-parcial {
  background: #2e2214;
  color: #e5a95c;
}

.item__nome {
  font-weight: 600;
  color: #5e5873;
  line-height: 1.3;
}

.local {
  font-weight: 500;
  color: #6e6b7b;
}

.lista td {
  vertical-align: middle;
}

.col-qtd {
  width: 70px;
}

.col-sit {
  width: 120px;
}

.col-per {
  width: 190px;
}

.col-proto {
  width: 150px;
}

.col-acoes {
  width: 120px;
}

.selo {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

.selo--retido {
  color: #ff9f43;
  background: rgba(255, 159, 67, 0.14);
}

.selo--recuperado {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.12);
}

.recuperada td {
  color: #a8aab5;
}

/* dark mode */
.dark-layout .resumo {
  color: #b4b7bd;
}

.dark-layout .tot__valor,
.dark-layout .item__nome,
.dark-layout .local {
  color: #d0d2d6;
}

.dark-layout .tot__valor--alerta {
  color: #e5a95c;
}

.dark-layout .tot__rotulo {
  color: #676d7d;
}

.liberar-equipe {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px dashed #ff9f43;
  border-radius: 6px;
  background: rgba(255, 159, 67, 0.06);
}

.dark-layout .recuperada td {
  color: #7a8194;
}
</style>
